
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.3.9 (bca860a39df8ba78ed898ccbc7dabcb6)",
    buildSeed: 1749215251012,
    "wdosbox-x.wasm": {
        "size": 6672510,
        "gzSize": 2409279
    },
    "wdosbox-x.js": {
        "size": 223823,
        "gzSize": 53825
    },
    "wdosbox.wasm": {
        "size": 1458738,
        "gzSize": 500055
    },
    "wdosbox.js": {
        "size": 106006,
        "gzSize": 28702
    },
    "wlibzip.wasm": {
        "size": 113081,
        "gzSize": 52376
    },
    "wlibzip.js": {
        "size": 74502,
        "gzSize": 20042
    }
,
};
